//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      roll: 0,
      timer: null,
    };
  },
  props: {
    upgrade_success_rate: {
      type: Number,
      default: 0,
    },
    minRollNum: {
      type: [Number, String],
      default: 0,
    },
    maxRollNum: {
      type: [Number, String],
      default: 0,
    },
    // roll:{
    //     type: Number,
    //     default: 0
    // }
  },
  computed: {
    initialAngle() {
      return (parseInt(this.minRollNum) / 1000000) * 360 - 90;
    },
  },
  mounted() {},

  methods: {
    onStartTurntable(winningSpin) {
      const cursor = this.$el.querySelector("#upgrade-circle-cursor");
      const roll = this.$el.querySelector("#roll");
      roll.style.opacity = 0;
      console.log("this.minRollNum===", this.minRollNum);
      console.log("this.maxRollNum===", this.maxRollNum);
      let min = "",
        max = "",
        lastMin = "",
        lastMax = "";
      if (this.minRollNum > this.maxRollNum) {
        min = -(1000000 - this.minRollNum);
        max = this.maxRollNum;
        lastMin = this.maxRollNum;
        lastMax = this.minRollNum;
      } else {
        min = this.minRollNum;
        max = this.maxRollNum;
        lastMin = -(1000000 - this.maxRollNum);
        lastMax = this.minRollNum;
      }
      console.log("min===", min);
      console.log("max===", max);
      console.log("lastMin===", lastMin);
      console.log("lastMax===", lastMax);
      console.log("winningSpin===", winningSpin);
      if (winningSpin) {
        let roll = Math.ceil(
          // this.randomNum(0, this.upgrade_success_rate * 10000)
          this.randomNum(min, max)
        );
        if (roll < 0) {
          this.roll = 1000000 + roll;
        } else {
          this.roll = roll;
        }
        console.log("成功数==", roll);
      } else {
        let roll1 = Math.ceil(
          // this.randomNum((this.upgrade_success_rate + 1) * 10000, 1000000)
          this.randomNum(lastMin, lastMax)
        );
        if (roll1 < 0) {
          this.roll = 1000000 + roll1;
        } else {
          this.roll = roll1;
        }
        console.log("失败数==", roll1);
      }

      let progressAngle = (this.roll / 1000000) * 360; // 計算對應的角度
      let rotations = 5; // 旋轉 5 圈
      let rotation = rotations * 360 + progressAngle; // 加上 progress 的角度

      let animationDuration = 3; // 動畫時間為 5 秒
      cursor.animate(
        [
          { transform: "rotate(0deg)" },
          { transform: `rotate(${rotation}deg)` },
        ],
        {
          duration: animationDuration * 1000,
          easing: "ease-out", // 減速
          fill: "forwards",
        }
      );
      this.timer = setTimeout(() => {
        clearTimeout(this.timer);
        roll.style.opacity = 1;
      }, 3000);
      return this.roll;
    },
    // // 生成 min 到 max 的随机数
    randomNum(minNum, maxNum) {
      return (
        Math.random() * (parseInt(maxNum) - parseInt(minNum) + 1) +
        parseInt(minNum)
      );
    },
  },
};
